// extracted by mini-css-extract-plugin
export default {"container":"bi6XpOPHyaXwgXtnsVyQ","infoBlock":"DIrirlPVFa1iTC6wS1sU","noteText":"GELc18N3Yj6VZoRMIsEv","dateView":"loeHaHAEnL4OEiHKztBv","controlsBox":"dHiih9rt5oG9tphbEe1U"};